import axios from 'axios';
import { isEmpty } from 'lodash';
import { useAuth } from 'hooks';
import { getUserLocationData } from 'utils';

let userInfo;

(() => {
	userInfo = useAuth();
})();

/**
 * set baseurl for all axios request
 */
axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.withCredentials = false; // to allow cookie to api request
axios.defaults.timeout = 28000; // Max timeout

// Add a request interceptor
axios.interceptors.request.use(
	async (config) => {
		// console.log('request interceptors', config.url);
		// Do something before request is sent
		if (isEmpty(userInfo)) {
			/**
			 * Sometime token will set on hard refresh,
			 */
			userInfo = useAuth();
		}

		try {
			if (!isEmpty(userInfo)) {
				const token = userInfo?.access_token;

				config.headers.Authorization = `Bearer ${token}`;
			}
		} catch (error) {
			console.log('catch', error);
		}

		// Add location headers for login requests only if location is available
		if (config.url && config.url.includes('/sales-men/login')) {
			try {
				const locationData = await getUserLocationData();

				// Only add headers if we have valid location data
				if (locationData.ip) {
					config.headers['x-user-ip'] = locationData.ip;
				}
				if (locationData.latitude !== null) {
					config.headers['x-user-latitude'] = locationData.latitude.toString();
				}
				if (locationData.longitude !== null) {
					config.headers['x-user-longitude'] = locationData.longitude.toString();
				}
			} catch (error) {
				console.warn('Error adding location headers:', error);
				// Don't add any headers if location data fails
			}
		}

		return config;
	},
	(error) =>
		// Do something with request error
		Promise.reject(error)
);

// Add a response interceptor
axios.interceptors.response.use(
	(response) =>
		// console.log('response interceptors', response);
		// Any status code that lie within the range of 2xx cause this function to trigger
		// Do something with response data
		response,
	(error) =>
		// Any status codes that falls outside the range of 2xx cause this function to trigger
		// Do something with response error
		Promise.reject(error)
);

export default axios;
